import React, { useState } from "react";
import Icon from "../../../../../../components/MainApp/atoms/Icon/icon";
import ItemTags from "components/MainApp/organisms/OrdersV3/Item-Tags";
import styles from "./PrepOrders.OrderDetail.VerifyMovementItems.module.scss";
import i18n from "i18n";

export const VerifyMovementItems = ({
  originalItems,
  selectedItems,
  total,
  handleEdit,
  handleConfirm,
  handleBack,
}) => {
  return (
    <div className={styles["verify-movement-items-outter"]}>
      <div className={styles["verify-movement-items-wrapper"]}>
        <div className={styles["verify-movement-items-header"]}>
          <div
            className={styles["verify-movement-items-title-wrapper"]}
            onClick={handleBack}
          >
            <div className={styles["verify-movement-items-title-icon"]}>
              {" "}
              <Icon name="chevron" width={14} height={14} fill={"#62D862"} />
            </div>
            <h1 className={styles["verify-movement-items-title"]}>
              {i18n.t("check.products.shipped")}
            </h1>
          </div>
          <div className={styles["verify-movement-items-button-wrapper"]}>
            <div
              className={styles["verify-movement-items-button-confirm-inner"]}
              onClick={handleConfirm}
            >
              {i18n.t("confirm")}
            </div>
          </div>
        </div>

        <div className={styles["verify-movement-items-content"]}>
          <div className={styles["verify-movement-items-list"]}>
            <div className={styles["prep-product-verify-header"]}>
              <div className={styles["prep-product-verify-left"]}>
                <div className={styles["prep-product-verify-top"]}>
                  {i18n.t("requested.products").toUpperCase()} {total}
                </div>
                <div className={styles["prep-product-verify-bottom"]}>
                  {i18n.t("loaded.products").toUpperCase()} {originalItems.length}
                </div>
              </div>
              <div
                className={styles["prep-product-verify-rigth"]}
                onClick={handleEdit}
                style={{ cursor: "pointer" }}
              >
                <Icon name="edit2" width={20} height={20} fill={"#3C7AF5"} />
              </div>
            </div>

            {selectedItems.map((item) => {
              return (
                <ItemTags
                  key={item.sku}
                  item={item}
                  quantity={item.tags.length}
                  expected={item.expectedUnits}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyMovementItems;
